import styled from 'glamorous'
import Link from 'react-router-dom/Link'

import { $ } from 'utils'
import { ImagePure } from 'components'

const Container = styled(Link)({
  position: 'relative',
  marginLeft: 6,
  marginBottom: 6,
  cursor: 'pointer',
  '&:before': {
    content: ' ',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    border: 'solid var(--violet)',
    borderWidth: 0,
    //transition: 'border var(--transition)',
    zIndex: 1
  },
  '&:hover:before': {
    borderWidth: 3,
  }
}, ({ selected }) => selected && {
  '&:before': {
    borderWidth: 3
  }
})

const FaceListItem = ({
  descriptor: { uuid, portrait },
  selected
}) =>
  $(Container, {
      key: uuid,
      to: {
        pathname: `/faces/${uuid}`,
        search: window.location.search,
      },
      selected
    },
    $(ImagePure, {
      src: portrait,
      width: 185,
      height: 240,
      isExtracted: true
    }))

export default FaceListItem



// WEBPACK FOOTER //
// ./src/pages/Faces/FaceListItem.js